"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const IAPIExchangeClient_1 = __importDefault(require("./IAPIExchangeClient"));
const ListSportsbookMarkets_1 = require("./calls/ListSportsbookMarkets/ListSportsbookMarkets");
const RequestSBMultipleBetCashOut_1 = require("./calls/RequestSBMultipleBetCashOut/RequestSBMultipleBetCashOut");
const RequestMultipleBetCashOutOffer_1 = require("./calls/RequestMultipleBetCashOutOffer/RequestMultipleBetCashOutOffer");
const RequestCashOutOffer_1 = require("./calls/RequestCashOutOffer/RequestCashOutOffer");
const GetSportsbookPrices_1 = require("./calls/GetSportsbookPrices/GetSportsbookPrices");
const PlaceBets_1 = require("./calls/PlaceBets/PlaceBets");
const CashOutSBMultipleBet_1 = require("./calls/CashOutSBMultipleBet/CashOutSBMultipleBet");
const PlaceSBMultipleBet_1 = require("./calls/PlaceSBMultipleBet/PlaceSBMultipleBet");
const RequestSBMultipleBetQuotation_1 = require("./calls/RequestSBMultipleBetQuotation/RequestSBMultipleBetQuotation");
const ListSBMultipleBets_1 = require("./calls/ListSBMultipleBets/ListSBMultipleBets");
const ListActiveSBMultipleBets_1 = require("./calls/ListActiveSBMultipleBets/ListActiveSBMultipleBets");
const ListTaggedValues_1 = require("./calls/ListTaggedValues/ListTaggedValues");
const GetExchangePrices_1 = require("./calls/GetExchangePrices/GetExchangePrices");
const RequestSBMultipleCustomBetQuotation_1 = require("./calls/RequestSBMultipleCustomBetQuotation/RequestSBMultipleCustomBetQuotation");
class IAPISportsbookClient extends IAPIExchangeClient_1.default {
    constructor(params) {
        super(params);
        this.listSportsbookMarkets = ListSportsbookMarkets_1.listSportsbookMarkets.bind(this);
        this.requestSBMultipleBetCashOut = RequestSBMultipleBetCashOut_1.requestSBMultipleBetCashOut.bind(this);
        this.requestMultipleBetCashOutOffer = RequestMultipleBetCashOutOffer_1.requestMultipleBetCashOutOffer.bind(this);
        this.requestCashOutOffer = RequestCashOutOffer_1.requestCashOutOffer.bind(this);
        this.getSportsbookPrices = GetSportsbookPrices_1.getSportsbookPrices.bind(this);
        this.placeBets = PlaceBets_1.placeBets.bind(this);
        this.cashOutSBMultipleBet = CashOutSBMultipleBet_1.cashOutSBMultipleBet.bind(this);
        this.placeSBMultipleBet = PlaceSBMultipleBet_1.placeSBMultipleBet.bind(this);
        this.requestSBMultipleBetQuotation = RequestSBMultipleBetQuotation_1.requestSBMultipleBetQuotation.bind(this);
        this.requestSBMultipleCustomBetQuotation = RequestSBMultipleCustomBetQuotation_1.requestSBMultipleCustomBetQuotation.bind(this);
        this.listSBMultipleBets = ListSBMultipleBets_1.listSBMultipleBets.bind(this);
        this.listActiveSBMultipleBets = ListActiveSBMultipleBets_1.listActiveSBMultipleBets.bind(this);
        this.listTaggedValues = ListTaggedValues_1.listTaggedValues.bind(this);
        this.getExchangePrices = GetExchangePrices_1.getExchangePrices.bind(this);
    }
}
exports.default = IAPISportsbookClient;
